<template>
  <div id="app">
<!-- 
  

    <vue-cookie-toggler
    v-on:accept="onAccept"
    v-if="
          ![
            'cookies'
          ].includes($route.name)
        "
      :cookies-groups="cookiesGroups"
      title="Vi använder cookies"
      settings-title="Cookie settings title"
      settings-label="Settings button label"
      accept-label="Accept button label"
      save-label="Save button label"
      cancel-label="Cancel button label"
    >


    <p>
      På BytBostad använder vi cookies både från vår egen webbplats
    och från externa parter för att erbjuda dig en optimal användarupplevelse,
    analysera trafik och presentera skräddarsytt innehåll. Genom att fortsätta
    använda vår webbplats samtycker du till användningen av cookies för dessa syften.
  </p>
  <p>Läs mer i vår  <router-link :to="{ name: 'cookies' }">
                  cookiepolicy
                </router-link></p>


      <template #settingsContent> Cookie settings message </template>

      <template #mainButtons="{ accept, settings }">
        <button class="vct__btn vct__btn--default" @click="settings">
          Ändra inställningar
        </button>
        <button class="vct__btn vct__btn--primary" @click="accept">
          Jag accepterar
        </button>
      </template>

      <template #settingsButtons="{ accept, save }">
        <button class="vct__btn vct__btn--default" @click="accept">
          Acceptera alla cookies
        </button>
        <button class="vct__btn vct__btn--primary" @click="save">
          Spara
        </button>
      </template>
    </vue-cookie-toggler>
   -->

    <!-- Covers the page (rather than replacing it) so views can mount, size
         their maps and load their content underneath before being revealed. -->
    <div v-if="!isListingPage && (!ready || pageLoading)" class="app-preloader">
      <Preloader />
    </div>
    <div v-if="ready || (isListingPage && routerReady)" v-cloak>
      <NavBar v-if="!['checkup'].includes($route.name)" />
      <router-view />
      <Footer
        v-if="
          [
            'home',
            'faq',
            'login',
            'ad',
            'my-account',
            'matches',
            'create-ad',
            'about-us',
            'jobs',
            'terms',
            'history',
            'lagenhetsbyte',
            'cookies',
          ].includes($route.name)
        "
      />
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
import Preloader from '@/components/Preloader.vue'

import VueCookieToggler from 'vue-cookie-toggler';

// import HelloI18n from './components/HelloI18n'
import { mapGetters } from 'vuex'

export default {
  components: {
    NavBar,
    Footer,
    Preloader,
    VueCookieToggler
  },
  methods: {

    onAccept() {
      console.log('Running the accept')
},
  },
  data(){
    return {
      // False until the session is loaded and the first route has resolved,
      // so nothing renders with the empty initial state and then flips.
      ready: false,
      routerReady: false,
      cookiesGroups: [
        {
          category: 'essential',
          name: 'Nödvändiga',
          description:
            'Cookies som krävs för att webbplatsen ska fungera korrekt. Dessa går inte att stänga av.',
          active: true,
          required: true,
        },
        {
          category: 'analytics',
          name: 'Analys och marknadsföring',
          description:
            'Cookies för statistik och marknadsföring som hjälper oss att förbättra webbplatsen och ge dig relevant innehåll.',
          active: true,
        },
        // {
        //   category: 'social_networking',
        //   name: 'Social networking',
        //   description:
        //     'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis. Suspendisse urna nibh, viverra non, semper suscipit, posuere a, pede.',
        //   active: false,
        // },
      ],
    }
  },

  computed: {
    ...mapGetters(['myAds', 'myActiveAd', 'pageLoading']),
    // Listing pages (/bostad/:id) never show the loader and don't wait for the
    // session, so crawlers get their content as soon as the route resolves.
    // Before the first route resolves, $route is still the placeholder '/',
    // so look at the URL instead.
    isListingPage() {
      if (!this.routerReady) {
        return /^\/bostad\//.test(window.location.pathname)
      }
      return this.$route.name === 'ad'
    }
  },

  watch: {
    myAds: {
      handler() {
        if (this.myActiveAd) {
          // console.log(this.myActiveAd)
          this.$store.dispatch('getMatches', this.myActiveAd).catch(() => {})
          // this.$router.push({ name: 'ad', params: { id: this.myActiveAd } })
        }

        if (this.myAds.length > 1) {
          // console.log('Du har flera annonser')
        }
      }
    }
  },
  mounted() {

    // console.log('Mounted app');
    this.$store.dispatch('getFrontpage').catch(() => {})
    const routerReady = new Promise(resolve => this.$router.onReady(resolve, resolve))
      .then(() => {
        this.routerReady = true
      })
    Promise.all([
      // Usually already started by the first route guard; this reuses that promise.
      this.$store.dispatch('initSession'),
      routerReady
    ]).then(() => {
      this.ready = true
    })
  },
  metaInfo() {
    return {
      // The SAME title and description as public/index.html and public/seo/home.html – the
      // first-pass HTML (page_server.php on the frontend host) and this runtime head must agree,
      // or Google sees two versions. Children override title / description per page. No brand
      // suffix: the server-side listing titles have none either (SEO, 2026-09-22).
      title: 'Lägenhetsbyte - byt din hyresrätt',
      titleTemplate: '%s',
      // Define meta tags here. vue-meta 1.x rewrites the tags in index.html that carry
      // data-vue-meta="true" (description, og:*, fb:app_id) – so one of each, never two.
      meta: [
        // {http-equiv: 'Content-Type', content: 'text/html; charset=utf-8'},
        // { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          vmid: 'description',
          name: 'description',
          content: 'Byt din hyresrätt på BytBostad. Direktbyten och triangelbyten för dig med förstahandskontrakt. Lägg upp din bostad och hitta ett lägenhetsbyte idag.'
        },
        { vmid: 'og:title', property: 'og:title', content: 'Lägenhetsbyte - byt din hyresrätt' },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: 'Byt din hyresrätt på BytBostad. Direktbyten och triangelbyten för dig med förstahandskontrakt. Lägg upp din bostad och hitta ett lägenhetsbyte idag.'
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          name: 'image',
          content: 'https://bytbostad.se/img/share.jpg'
        },
        { vmid: 'fb:app_id', property: 'fb:app_id', content: '162588207446399' },
        { vmid: 'og:type', property: 'og:type', content: 'website' }
      ]
    }
  }
}
</script>

<style lang="scss">
// @import '../styles/index.scss';
@import 'scss/main.scss';
[v-cloak] {
  display: none !important;
}
.app-preloader {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // Maximum z-index: the site already uses values up to 999999
  // (.card-controls in _cardapp.scss), and nothing may sit above the loader.
  z-index: 2147483647;
}
html {
  touch-action: manipulation;
}
.v--modal-overlay{
  z-index: 99999;
}
.v--modal{
  border-radius:1rem;
  overflow:hidden;
  font-family: "Nunito", sans-serif;
  font-weight: 600;;
}
#cookieConsentModal .cookieConsent-modal{
  font-family: "Nunito", sans-serif;

}
.cookie-consent_modal, .cookieConsent-modal__body, .cookie-consent_modal__header-title{
  font-family: "Nunito", sans-serif;
}

#cookieConsentModal {
  font-family: "Nunito", sans-serif!important;
  font-weight: 600!important;
  // color:red;
}
.cookie-consent_modal .vct__btn {
  font-family: "Nunito", sans-serif;
}

#cookieConsentModal > div > div.cookie-consent_modal__footer > button.vct__btn.vct__btn--default{
  font-family: "Nunito", sans-serif;
  font-weight: 600;;
}

#cookieConsentModal > div > div.cookie-consent_modal__footer > button.vct__btn.vct__btn--primary{
  font-family: "Nunito", sans-serif;
  font-weight: 600;
}


.cookieConsent-modal__body p {
  padding-bottom:20px;
  line-height: 1.5;
}

</style>
